
    import {
      getAllPrograms,
      createProgram,
      createAllPrograms,
      updateProgram,
      deleteProgram
    } from "@/services/program";

    const state = {
      programs: [],
      processed: false
    };

    const getters = {
      getPrograms(state) {
        return state.programs;
      },
      programProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchPrograms({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllPrograms(
              params
            )
              .then(response => {
                commit("SET_PROGRAMS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createProgram({ commit }, { program, locationIds }) {
          return new Promise((resolve, reject) => {
            createProgram(program, locationIds)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllPrograms({ commit }, programs) {
          return new Promise((resolve, reject) => {
            createAllPrograms(programs)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateProgram({ commit }, { program }) {
          return new Promise((resolve, reject) => {
            updateProgram(program)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteProgram({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteProgram(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_PROGRAMS(state, data) {
        state.programs = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    